module.exports = __webpack_public_path__ + "img/credit-card.f67d3311.svg";